import React, { useContext, useEffect, useState } from "react";
import { PanelContainer } from "../Cpanel/Components/PanelContainer";
import DataTableTemplate from "../Cpanel/Components/DataTableTemplate";
import { fetchData, sendPostRequest } from "../Cpanel/Components/Utilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ShopContext } from "../StateManagement/Contexts/ShopContext";

export const Returned = () => {
  const [pageData, setPageData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [defaultRows, setDefaultRows] = useState(20);
  const [defaultDatatableRows, setDefaultDatatableRows] = useState(10);
  const { shopData } = useContext(ShopContext);
  const [lazyState, setLazyState] = useState({
    first: 0,
    page: 0,
    rows: defaultRows,
  });

  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("pageNo", lazyState?.page + 1 ?? 1);
    bodyFormData.append("pageSize", lazyState?.rows ?? 20);
    if (shopData?.Token) {
      sendPostRequest(
        "cashbacklist",
        "token",
        shopData?.Token,
        bodyFormData,
        handleCreateCatResponse
      );
    }
  }, [shopData?.Token]);

  const handleCreateCatResponse = (data) => {
    console.log(data);
    setPageData(data?.data);
    setTotalRecords(data?.count);
  };
  const cols = [
    {
      field: "buyername",
      header: "ردیف",
      body: (data, options) => options.rowIndex + 1,
    },
    {
      field: "buyername",
      header: "شماره سبد",
    },
    { field: "cashback", header: "تاریخ مرجوع" },
    {
      field: "basketid",
      header: "نام خریدار",
    },
    {
      field: "pic",
      header: "آیتم مرجوعی",
    },
    // { field: "MaxsimumCashBack", header: "حداکثر کش بک" },
    // {
    //   field: "CityName",
    //   header: "ویرایش",
    //   body: (data, options) => (
    //     <div className="my-1">
    //       <FontAwesomeIcon
    //         icon={"edit"}
    //         // onClick={() => handleOpeEditItem(data)}
    //         className="icon-sm prime-bg text-white p-1 text-center rounded"
    //         color="gray"
    //       />
    //     </div>
    //   ),
    // },
  ];

  return (
    <PanelContainer title={"کش بک ها"}>
      <DataTableTemplate
        lazyState={lazyState}
        // header={header}
        // select='select'
        className={"table-border"}
        columns={cols}
        list={pageData}
        totalRecords={totalRecords}
        setlazyState={setLazyState}
        setDefaultDatatableRows={setDefaultDatatableRows}
        defaultDatatableRows={defaultDatatableRows}
        width="25rem"
      />
    </PanelContainer>
  );
};
